import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "article.covid.title",
    },
    p1: {
        id: "article.covid.p1",
    },
    alert1: {
        id: "article.covid.alert1",
    },
    title2: {
        id: "article.covid.title2",
    },
    p2: {
        id: "article.covid.p2",
    },
    li1: {
        id: "article.covid.li1",
    },
    li2: {
        id: "article.covid.li2",
    },
    h2: {
        id: "article.covid.h2",
    },
    p3: {
        id: "article.covid.p3",
    },
    p4: {
        id: "article.covid.p4",
    },
    tip: {
        id: "article.covid.tip",
    },
    title3: {
        id: "article.covid.title3",
    },
    p5: {
        id: "article.p5",
    },
    d1: {
        id: "article.covid.d1",
    },
    li3: {
        id: "article.covid.li3",
    },
    li4: {
        id: "article.covid.li4",
    },
    d2: {
        id: "article.covid.d2",
    },
    d3: {
        id: "article.covid.d3",
    },
    tip2: {
        id: "article.covid.tip2",
    },
    tab1: {
        id: "article.covid.tab1",
    },
    tab2: {
        id: "article.covid.tab2",
    },
    benefits: {
        id: "article.covid.benefits",
    },
});

export default messages;
